import { css, injectGlobal } from '@emotion/css'

// --- Color palette ---
export const colors = {
  // Brand
  brand: '#ff5c5c',
  brandLight: '#ffe0e0',
  brandDark: '#cc3333',

  // Backgrounds
  bg: '#fffaf5',
  bgCard: '#ffffff',
  bgSidebar: '#fef6f0',

  // Message roles
  msgUser: '#ffe4e4',
  msgAssistant: '#f5f5f5',
  msgSystem: '#ececec',

  // Text
  text: '#1a1a1a',
  textSecondary: '#666666',
  textMuted: '#999999',

  // Accents
  teal: '#4ecdc4',
  yellow: '#ffe66d',
  pink: '#ff6b8a',
  purple: '#c792ea',
  blue: '#74c0fc',
  green: '#a9e34b',
  orange: '#ffa94d',

  // Criticality
  critical: '#ff5c5c',
  important: '#ffa94d',
  info: '#74c0fc',

  // UI
  border: '#e8e0da',
  borderFocus: '#ff5c5c',
  shadow: 'rgba(0, 0, 0, 0.06)',
}

// --- Typography ---
export const font = {
  family: "'Lexend', sans-serif",
  size: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '2rem',
  },
  weight: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
}

// --- Spacing ---
export const space = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
  '2xl': '3rem',
}

// --- Global styles ---
injectGlobal`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body {
    font-family: ${font.family};
    font-size: 16px;
    color: ${colors.text};
    background: ${colors.bg};
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
  }

  a {
    color: ${colors.brand};
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  button {
    font-family: ${font.family};
    cursor: pointer;
  }

  input, textarea, select {
    font-family: ${font.family};
  }
`

// --- Reusable style fragments ---

export const card = css`
  background: ${colors.bgCard};
  border: 1px solid ${colors.border};
  border-radius: 8px;
  padding: ${space.lg};
`

export const btn = css`
  display: inline-flex;
  align-items: center;
  gap: ${space.sm};
  padding: ${space.sm} ${space.md};
  border-radius: 6px;
  font-size: ${font.size.sm};
  font-weight: ${font.weight.medium};
  border: none;
  transition: all 0.15s ease;
`

export const btnPrimary = css`
  ${btn};
  background: ${colors.brand};
  color: white;
  &:hover { background: ${colors.brandDark}; }
`

export const btnSecondary = css`
  ${btn};
  background: ${colors.bgCard};
  color: ${colors.text};
  border: 1px solid ${colors.border};
  &:hover { background: ${colors.bg}; }
`

export const input = css`
  width: 100%;
  padding: ${space.sm} ${space.md};
  border: 1px solid ${colors.border};
  border-radius: 6px;
  font-size: ${font.size.base};
  background: ${colors.bgCard};
  color: ${colors.text};
  outline: none;
  transition: border-color 0.15s ease;
  &:focus { border-color: ${colors.borderFocus}; }
`

export const label = css`
  display: block;
  font-size: ${font.size.sm};
  font-weight: ${font.weight.medium};
  color: ${colors.textSecondary};
  margin-bottom: ${space.xs};
`
